import { z } from 'zod';
import { MoneySchema, QuantitySchema } from '../../../domain/shared/types';

export const CreateProductDTOSchema = z.object({
  name: z.string().min(1, 'Product name is required'),
  sku: z.string().min(1, 'SKU is required'),
  description: z.string().optional(),
  barcode: z.string().optional(),
  category: z.string().optional(),
  cost: MoneySchema,
  price: MoneySchema,
  minQuantity: QuantitySchema,
  maxQuantity: QuantitySchema.optional(),
  isActive: z.boolean().optional().default(true),
  // Initial inventory fields (optional)
  initialQuantity: z.number().min(0, 'Initial quantity must be non-negative').optional(),
  warehouseId: z.string().optional(),
  locationId: z.string().optional(),
}).refine(
  (data) => {
    // If initialQuantity is provided, warehouseId must also be provided
    if (data.initialQuantity !== undefined && data.initialQuantity > 0) {
      return data.warehouseId !== undefined && data.warehouseId.length > 0;
    }
    return true;
  },
  {
    message: 'Warehouse ID is required when initial quantity is provided',
    path: ['warehouseId'],
  }
);

export interface CreateProductDTO {
  name: string;
  sku: string;
  description?: string;
  barcode?: string;
  category?: string;
  cost: {
    amount: number;
    currency: string;
  };
  price: {
    amount: number;
    currency: string;
  };
  minQuantity: {
    value: number;
    unit: string;
  };
  maxQuantity?: {
    value: number;
    unit: string;
  };
  isActive?: boolean;
  // Initial inventory fields (optional)
  initialQuantity?: number;
  warehouseId?: string;
  locationId?: string;
}
